import { DateFormats } from 'UI/constants/defaults';
import { toLocalTime } from 'UI/utils';

export const EMPTY_VALUE = '---';

export const formatCallDateTime = date =>
  (date && toLocalTime(date).format(DateFormats.SimpleDateTime)) || EMPTY_VALUE;

export const getDebriefFileName = file =>
  file?.original_name || file?.file_name || file?.fileName || EMPTY_VALUE;
